import React from 'react';
import { useNavigate } from 'react-router';
import { SurveyStates } from '../../../../common/src/enums/SurveyStates';
import { getRequestBodySchema } from '../../../../common/src/routes/openApiSchemaHelpers';
import { useTranslate } from '../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    Panel,
    PanelBody,
    PanelButton,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../elements';
import { ValidatingJsonSchemaForm } from '../validatingComponents/ValidatingJsonSchemaForm';
import { ValidatingEditPanelSaveButton, ValidatingFilterDropdown, ValidatingFormInputText } from '../validatingElements';

export function TaskDefinitionAddEdit(props: { params: { id?: string } }) {
    const translate = useTranslate();
    const navigate = useNavigate();

    function handleSavedOrCancelled() {
        navigate('/settings/taskdefinitions');
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    {(props.params.id && <TopbarCrumbActive title={translate('common.editItem', translate('workflow.task'))} icon="fa-cogs" />) || (
                        <TopbarCrumbActive title={translate('common.addItem', translate('workflow.task'))} icon="fa-cogs" />
                    )}
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small>
                        <PanelBody noPadding>
                            <ValidatingJsonSchemaForm
                                createSchema={getRequestBodySchema('/api/settings/taskDefinitions', 'post')}
                                updateSchema={getRequestBodySchema('/api/settings/taskDefinitions/{taskDefinitionId}', 'post')}
                                createUrl={'/api/settings/taskDefinitions/'}
                                updateUrl={`/api/settings/taskDefinitions/${props.params.id}`}
                                itemUrl={`/api/settings/taskDefinitions/${props.params.id}`}
                                id={props.params.id}
                                onSubmitted={handleSavedOrCancelled}
                                defaultItem={{}}
                            >
                                <EditPanel>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={12}>
                                            <ValidatingFormInputText name="name" topLabel={translate('common.name')} />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <ValidatingFilterDropdown
                                                name="surveyStatus"
                                                topLabel="Status"
                                                selectOptions={
                                                    [
                                                        SurveyStates.Open,
                                                        SurveyStates.Preparation,
                                                        SurveyStates.Conducting,
                                                        SurveyStates.Reporting,
                                                        SurveyStates.Delivery,
                                                    ].map((i) => ({ value: i, text: translate(`surveyStatus.${i}`) })) ?? []
                                                }
                                            />
                                        </EditPanelCell>
                                        <EditPanelCell rowCount={3}>
                                            <ValidatingFormInputText name="order" topLabel={translate('common.order')} />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                </EditPanel>
                                <EditPanelButtons footer>
                                    <PanelButton text={translate('common.cancel')} onClick={handleSavedOrCancelled} />
                                    <ValidatingEditPanelSaveButton />
                                </EditPanelButtons>
                            </ValidatingJsonSchemaForm>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
